import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What tools are commonly used in Data Analytics?",
    category: "Technology",
    description:
      "What tools are commonly used in Data Analytics?",
  },
  {
    title: "What job roles are available in Data Analytics?",
    category: "Trending",
    description:
      "Common roles include Data Analyst, Business Analyst, Marketing Analyst, Financial Analyst, Product Analyst, Operations Analyst, Reporting Analyst, and MIS Executive. Each role focuses on analyzing data to support business decisions.",
  },
  {
    title: "What is the difference between Data Analytics and Data Science?",
    category: "Design",
    description:
      "Data Analytics focuses on analyzing historical data to solve business problems. Data Science goes deeper into machine learning, predictive modeling, and AI. Analytics = Insights; Data Science = Predictions + advanced modeling.",
  },
  {
    title: "Is Data Analytics good for freshers?",
    category: "Design",
    description:
      "Yes. Data Analytics is one of the most beginner-friendly and high-demand career paths. Freshers can enter the field with the right skills, projects, and certifications.",
  },
  {
    title: "What is data cleaning and why is it important?",
    category: "Design",
    description:
      "Data cleaning involves fixing errors, handling missing values, removing duplicates, and organizing datasets. Clean data is essential because incorrect or messy data leads to wrong insights.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
